import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var ThumbsUp = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.887 17.587h-9.796l1.899-3.404c.9-1.602 1.4-3.405 1.4-5.307 0-3.704-2.3-6.908-5.599-8.21-2.099-.901-4.298.801-4.298 3.004v.5c0 .4 0 .701-.1 1.102-.3 3.204-2 6.107-4.598 8.21l-3.799 2.903v-1.201c0-.6-.5-1.001-1-1.001H3c-.6 0-1 .5-1 1.001v28.235c0 .6.5 1 1 1h8.996c.6 0 1-.5 1-1v-2.003c5.298 1.502 11.096 2.603 16.794 2.603.9 0 1.8 0 2.799-.1 1.1-.1 2.2-.3 3.099-.8 1-.501 1.8-1.302 2.299-2.504.7-1.602 1-3.404 1.3-5.006.1-.4.1-.8.2-1.201.3-1.502.6-3.004 1-4.606.1-.5.199-1.001.399-1.502.5-2.102.9-4.205 1.1-6.308.2-2.403-1.7-4.405-4.099-4.405Zm-26.89 24.73H4.099V16.285h6.898v26.032ZM38.787 27.9l-.3 1.501c-.3 1.502-.7 3.104-1 4.706-.1.5-.2 1.002-.2 1.402-.2 1.602-.5 3.004-1.1 4.305-.4.801-.8 1.202-1.399 1.502-.6.3-1.4.5-2.299.5-6.398.401-13.095-.8-19.393-2.602V19.089l4.998-4.005c2.9-2.403 4.998-5.807 5.298-9.612.1-.4.1-.901.1-1.302v-.6c0-.801.8-1.302 1.5-1.102C27.49 3.47 29.29 5.872 29.29 8.776c0 1.502-.4 3.004-1.1 4.305l-2.699 4.906c-.2.3-.2.701 0 1.002.2.3.5.5.9.5h11.596c1.2 0 2.1 1.002 2 2.203-.3 2.103-.7 4.205-1.2 6.208Z"
  }));
});
ThumbsUp.displayName = 'ThumbsUp';
ThumbsUp.defaultProps = {
  'aria-label': 'ThumbsUp'
};
export default ThumbsUp;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/ThumbsUp.js
// module id = 3934
// module chunks = 11